import { useState } from "react";
import { Select } from "native-base";
import BulkActionButton from "./BulkActionButton";
import BulkActionRetourLetter from "./BulkActionRetourLetter";
import BulkActionFinalCoverLetter from "./BulkActionFinalCoverLetter";
import BulkActionCoverLetter from "./BulkActionCoverLetter";
import BulkActionSetProtocolTimestamps from "./BulkActionSetProtocolTimestamps";

const AVAILABLE_ACTIONS = [
  { value: "retour-letter", label: "Retourbriefe generieren" },
  { value: "cover-letter", label: "Begleitschreiben Eigentümer generieren" },
  {
    value: "final-cover-letter",
    label: "Begleitschreiben Schlussexemplar generieren",
  },
  {
    value: "sentToOwnerAt",
    label: "Status Protokol: An Eigentümer verschickt",
  },
  {
    value: "returnedFromOwnerAt",
    label: "Status Protokol: Von Eigentümer zurück",
  },
  {
    value: "sentToClientAt",
    label: "Status Protokol: An Auftraggeber verschickt",
  },
  {
    value: "returnedFromClientAt",
    label: "Status Protokol: Von Auftraggeber zurück",
  },
  {
    value: "sentFinalToOwnerAt",
    label: "Status Protokol: Final an Eigentümer verschickt",
  },
  {
    value: "manualClosureAt",
    label: "Status Protokol: Manuelle Schliessung",
  },
];

type Action = (typeof AVAILABLE_ACTIONS)[number]["value"];

const TIMESTAMP_ACTIONS = [
  "sentToOwnerAt",
  "returnedFromOwnerAt",
  "sentToClientAt",
  "returnedFromClientAt",
  "sentFinalToOwnerAt",
  "manualClosureAt",
] as const;

export type ProtocolTimestampAction = (typeof TIMESTAMP_ACTIONS)[number];

interface ObjectBulkActionsProps {
  projectId: string;
  objectIds: string[];
}

export default function ObjectBulkActions({
  projectId,
  objectIds,
}: ObjectBulkActionsProps) {
  const [action, setAction] = useState<Action | "">("");

  return (
    <>
      <Select
        size="md"
        placeholder="Mehrfachaktion auswählen..."
        selectedValue={action}
        onValueChange={setAction}
        width="300"
        mr={4}
      >
        {AVAILABLE_ACTIONS.map(({ value, label }) => (
          <Select.Item key={value} label={label} value={value} />
        ))}
      </Select>

      {!action && (
        <BulkActionButton
          onPress={() => {}}
          isDisabled={!action || objectIds.length === 0}
        />
      )}

      {action === "retour-letter" && (
        <BulkActionRetourLetter projectId={projectId} objectIds={objectIds} />
      )}

      {action === "cover-letter" && (
        <BulkActionCoverLetter projectId={projectId} objectIds={objectIds} />
      )}

      {action === "final-cover-letter" && (
        <BulkActionFinalCoverLetter
          projectId={projectId}
          objectIds={objectIds}
        />
      )}

      {action === "final-cover-letter" && (
        <BulkActionFinalCoverLetter
          projectId={projectId}
          objectIds={objectIds}
        />
      )}

      {TIMESTAMP_ACTIONS.includes(action as any) && (
        <BulkActionSetProtocolTimestamps
          action={action}
          title={AVAILABLE_ACTIONS.find((a) => a.value === action)?.label ?? ""}
          projectId={projectId}
          objectIds={objectIds}
        />
      )}
    </>
  );
}
